var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 64,
    viewBox: "0 0 75 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8288 37.3333C40.8288 39.1733 39.3354 40.6666 37.4954 40.6666C35.6554 40.6666 34.1621 39.1733 34.1621 37.3333V24C34.1621 22.16 35.6554 20.6666 37.4954 20.6666C39.3354 20.6666 40.8288 22.16 40.8288 24V37.3333ZM37.4954 50.6667C35.6554 50.6667 34.1621 49.1733 34.1621 47.3333C34.1621 45.4933 35.6554 44 37.4954 44C39.3354 44 40.8288 45.4933 40.8288 47.3333C40.8288 49.1733 39.3354 50.6667 37.4954 50.6667ZM72.6998 48.3433L47.1264 5.94663C45.1298 2.63996 41.5298 0.666626 37.4964 0.666626C33.4631 0.666626 29.8631 2.63996 27.8664 5.94663L2.29312 48.3433C0.399782 51.4866 0.343115 55.2666 2.14312 58.4533C4.07312 61.8766 7.82311 64 11.9231 64H63.0698C67.1698 64 70.9198 61.8766 72.8498 58.4533C74.6498 55.2666 74.5931 51.4866 72.6998 48.3433Z",
    fill: "#F2C94C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.26d49ac8d77c335135b2821189b276f7.svg";
export { ForwardRef as ReactComponent };